import { Component, computed, ElementRef, inject, OnDestroy, ViewChild } from '@angular/core';
import { MenuComponent } from '../menu/menu.component';
import { LayoutService } from '@/core/services/layout/layout.service';
import { MenuProfileComponent } from '../menuprofile/menuprofile.component';

@Component({
    selector: '[app-sidebar]',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false,
})
export class SidebarComponent implements OnDestroy {
    el = inject(ElementRef);

    layoutService = inject(LayoutService);

    @ViewChild(MenuComponent) appMenu!: MenuComponent;

    @ViewChild('menuProfileStart') menuProfileStart!: MenuProfileComponent;

    @ViewChild('menuProfileEnd') menuProfileEnd!: MenuProfileComponent;

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    overlayMenuActive = computed(() => this.layoutService.layoutState().overlayMenuActive);

    menuProfilePosition = computed(() => this.layoutService.layoutConfig().menuProfilePosition);

    anchored = computed(() => this.layoutService.layoutState().anchored);

    timeout: any;

    resetOverlay() {
        if (this.overlayMenuActive()) {
            this.layoutService.layoutState.update((val) => ({ ...val, overlayMenuActive: false }));
        }
    }

    onMouseEnter() {
        if (!this.anchored()) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.layoutService.layoutState.update((val) => ({ ...val, sidebarActive: true }));
        }
    }

    onMouseLeave() {
        if (!this.anchored()) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => this.layoutService.layoutState.update((val) => ({ ...val, sidebarActive: false })), 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((val) => ({ ...val, anchored: !val.anchored }));
    }

    ngOnDestroy() {
        this.resetOverlay();
    }
}
